@for (option of optionGroup?.options; track option.id; let isFirst = $first; let isLast = $last) {
    <ms-event-pick
        class="grid-option-selectable"
        [option]="option"
        [class.offline]="!option.online"
        [event]="event"
        [optionGroup]="optionGroup"
        [trackingSource]="tracking.source"
        [trackingPosition]="tracking.position">
        @if (!(optionGroup.online && option.online)) {
            <vn-icon name="theme-locked-i" size="14" />
        } @else {
            <div class="event-pick-data">
                <div class="option-attribute">
                    {{ getResultName(option) }}
                </div>
            </div>
            <div class="result-odds option-value">
                <ms-font-resizer [defaultSize]="1" [maxChars]="6" [value]="option.nativePrice | msNativePriceFormatter" />
            </div>
        }
    </ms-event-pick>
}
